import { languages } from '../constants/languages';

export const languageSortFilterModule = angular
  .module('Q.filters.language-sort', [])
  .filter('languageFilter', function () {
    return function languageFilter(arr) {
      return arr.filter((l) => languages.getLang(l));
    };
  })
  .filter('languageSort', function () {
    return function languageSort(arr, primary) {
      return arr
        .slice()
        .sort(primary ? languages.primaryCompare : languages.compare);
    };
  });
